import { render, staticRenderFns } from "./AdminEnAttenteTermine.vue?vue&type=template&id=cdeddd46&"
import script from "./AdminEnAttenteTermine.vue?vue&type=script&lang=js&"
export * from "./AdminEnAttenteTermine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports